const STORAGE_KEY = 'xgain_active_account_id';

export const getActiveAccountId = () => sessionStorage.getItem(STORAGE_KEY) || '';

export const setActiveAccountId = (accountId) => {
  if (!accountId) {
    sessionStorage.removeItem(STORAGE_KEY);
    return;
  }
  sessionStorage.setItem(STORAGE_KEY, String(accountId));
};

export const clearActiveAccountId = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export const getAccountShortLabel = (name) => {
  const normalized = String(name || '').trim();
  if (normalized === 'Matt A') return 'MA';
  if (normalized === 'Matt iTrust') return 'Mi';
  if (!normalized) return '';
  const parts = normalized.split(/\s+/);
  if (parts.length >= 2) {
    return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
  }
  return normalized.slice(0, 2);
};
